module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-300.234e240352293e69cc0923e2ca2d198d.woff2";